document.addEventListener('DOMContentLoaded', function () {
	const marquee = document.querySelector('.marquee');
	if (!marquee) return;

	const container = marquee.querySelector('.marquee__inner');
	const text = marquee.dataset.marqueeText;

	const span = document.createElement('span');
	span.textContent = text;
	container.appendChild(span);

	requestAnimationFrame(() => {
		const spanWidth = span.offsetWidth;
		const containerWidth = marquee.offsetWidth;

		let totalWidth = spanWidth;
		while (totalWidth < containerWidth * 2) {
			const clone = span.cloneNode(true);
			container.appendChild(clone);
			totalWidth += spanWidth;
		}

		const speed = 250;
		const duration = totalWidth / speed;

		container.style.animationDuration = `${duration}s`;
	});
});
